import React, { Component } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import {Modal} from '@material-ui/core'
import { Player } from 'video-react';
import Header from './Header'



class HowWorks extends Component {

        state={
            collapseID:'',
            addClass:'faqQuestionActive',
            removeClass:'faqQuestionPassive',
            modalVisible:false,
            videoName:'kassa_register_v1.mp4'
        };

        clickBTN = (collapseID,e) => {
    
            this.setState(prevState => ({
                collapseID: prevState.collapseID !== collapseID ? collapseID : ""
              }));
        }
        openModal =()=>{
            this.setState({
                modalVisible:true
            })
        }
        closeModal = () =>{
            this.setState({
                modalVisible:false
            })
        }
    render() {
        return (
            <div className="mainContainer">
            <Header/>
            <div className="faqContainer">
                <div className="faqHeader">
                    <h1>NASIL ÇALIŞIR?</h1>
                </div>
                <Accordion>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" className={`faqQuestion ${this.state.collapseID==='0' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("0")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#" onClick={this.openModal.bind(this)}><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="1" className={`faqQuestion ${this.state.collapseID==='1' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("1")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="2" className={`faqQuestion ${this.state.collapseID==='2' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("2")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="3" className={`faqQuestion ${this.state.collapseID==='3' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("3")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="4" className={`faqQuestion ${this.state.collapseID==='4' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("4")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="5" className={`faqQuestion ${this.state.collapseID==='5' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("5")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="5">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="6" className={`faqQuestion ${this.state.collapseID==='6' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("6")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="6">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="7" className={`faqQuestion ${this.state.collapseID==='7' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("7")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="7">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="8" className={`faqQuestion ${this.state.collapseID==='8' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("8")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="8">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                    <Accordion.Toggle as={Card.Header} eventKey="9" className={`faqQuestion ${this.state.collapseID==='9' ? this.state.addClass : this.state.removeClass }`} onClick={() => this.clickBTN("9")}>
                            Durum ne işe yarar?
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="9">
                            <Card.Body>
                                <div className="faqAnswers">
                                    <div className="answerLeft">
                                        <p>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.<br/><br/>
                                            Çıkacağın tatili ya da gideceğin konseri arkadaşlarınla sohbet ederek planlıyorsan, harcamaları da aynı sohbet ekranından paylaşabilirsin. Kassa’nın sohbet arayüzü sayesinde masrafları bölüşmek çok daha kolay.
                                        </p>

                                            <a href="#"><img
                                            src={require('../images/play_icon.svg')}
                                            />
                                            <span>Video İzle</span>
                                            </a>

                                    </div>
                                    <div className="answerRight">
                                        <img 
                                        src={require('../images/faq_image.png')} 
                                        srcSet={`
                                            ${require('../images/faq_image@2x.png')} 2x, 
                                            ${require('../images/faq_image@3x.png')} 3x, 
                                        `}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.modalVisible}
                    onClose={this.closeModal}
                    className="videoContainer"
                >
                    <div >
                    <Player
                        playsInline
                        width={450}
                        fluid={false}
                        src={"http://www.kassa.co/videos/" + this.state.videoName}
                    />
                    </div>
                </Modal>
            </div>
            </div>
        )
    }
}

export default HowWorks